<template>
	<div ref="">
		<div class="SiftPanel" style="border:0px solid #bbbbbb; height:30px;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px; color:#aaaaaa;">客户名称</div>
			<input type="text" style="width:240px;" maxlength="30" v-model="custName" disabled=true>
		</div>
		<div class="SiftPanel" style="border:0px solid #bbbbbb; height:30px; margin-top:5px;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px; color:#aaaaaa;">有效期至</div>
			<input type="text" style="width:240px;" maxlength="30" v-model="preValidateText" disabled=true>
		</div>
		<div class="SiftPanel" style="border:0px solid #bbbbbb; height:30px; margin-top:5px;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px; color:#aaaaaa;">设备状态</div>
			<input type="text" style="width:240px;" maxlength="30" v-model="preStsText" disabled=true>
		</div>
		<div class="SiftPanel" style="border:0px solid #bbbbbb; height:30px; margin-top:5px;">
			<div style="width:100%; height:1px; background:#bbbbbb;"></div>
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb; height:40px;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px; color:#ff0000;  margin-top:-1px; margin-left:20px;">硬件编码</div>
			<input type="text" style="width:240px;" maxlength="30" v-model="devHdcode">
			<div class="NButton DIVNoSelect" style="width:32px; height:32px; background:url(../static/images/op_fin.png); margin-top:-1px; margin-left:10px;" @click="onDevInfoClick"></div>
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb; height:40px;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;  color:#ff0000;">销售</div>
			<input type="text" style="width:240px;" maxlength="20" v-model="dfPayChannel">
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb; height:40px;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px; color:#ff0000;">订单号</div>
			<input type="text" style="width:240px;" maxlength="50" v-model="dfCertificate">
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb; height:40px;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px; color:#ff0000;">购买时长</div>
			<input type="text" style="width:240px;" maxlength="4" v-model="dfBuyMonths">
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb; height:40px;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;">金额</div>
			<input type="text" style="width:240px;" maxlength="8" v-model="dfPayAmount">
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb; height:40px;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;">币种</div>
			<check style="height:30px; margin-right:10px; margin-left:0px;"  :size="18" :grpName="'GrpCurrency'" :val="156" :capt="'RMB'" :checked="false"></check>
			<check style="height:30px; margin-right:20px;"                   :size="18" :grpName="'GrpCurrency'" :val="840" :capt="'USD'" :checked="true"></check>
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb; height:40px;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;">付款日期</div>
			<input type="text" style="width:240px;" maxlength="8" v-model="dfPayDate" placeholder="yyyymmdd">
		</div>

		<div style="float:left; width:100%; height:40px; border:0px solid red; margin-top:10px;">
			<div class="NButton DIVNoSelect" style="padding-left:10px; padding-right:10px; margin-top:16px; margin-left:70px;" @click="onCancelClick">取消</div>
			<div class="NButton DIVNoSelect" style="padding-left:10px; padding-right:10px; margin-top:16px; margin-right:70px; float:right;" @click="onOKClick">确定</div>
		</div>
	</div>
</template>

<script>

import check      from '../cf/cck'

export default {
	name: 'feeNew',
	components:{
		check,
	},
	data () {
		return {
			devId: "",                   // 设备ID
			devHdcode: "",               // 硬件编码
			custName: "",                // 客户名称
			preValidate: "",             // 执行前有效期
			preValidateText: "",
			preSts: "",                  // 执行前状态
			preStsText: "",
			devFound: true,              // 是否查询到设备
			dfPayChannel: "",            // 支付通道
			dfPayAmount: "9900",         // 付款金额
			dfPayCurrency: "",           // 币种
			dfPayDate: "",               // 付款日期
			dfCertificate: "",           // 收款凭证
			dfBuyMonths: "12",           // 购买的时间长度
		}
	},
	mounted: function(){
		this.dfPayDate = this.getDateInt();
	},
	computed:{

	},
	methods:{
		onDevInfoClick: function(){
			let body={ pageSize:10, curPage:0, devHdcode: this.devHdcode };

			this.doTrade( "POST", ServAddr+"/api/device/queryBySn", this.onDevInfoOK, true, body, null );
		},
		onDevInfoOK: function(res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			this.devId = data.body.devList[0].devId;
			this.preSts = data.body.devList[0].devSts;
			this.preStsText = this.getDevStsText(this.preSts);
			this.preValidate = data.body.devList[0].devValidate;
			this.preValidateText = this.splitYMD(this.preValidate, 1);
			this.custName        = data.body.devList[0].devCustName;
		},
		onCancelClick: function(){
			this.$parent.onPopWinClose( );
		},
		onOKClick: function( ){
			if( this.devId=="" || this.devId==0 ) return;

			this.dfPayCurrency = this.getCheckValuesByName( "GrpCurrency");
			let body={	devId: this.devId,
						dfPayChannel: this.dfPayChannel,
						dfPayAccount: "***",
						dfPayAmount:  parseInt(this.dfPayAmount),
						dfPayCurrency: this.dfPayCurrency,
						dfPayDate: this.dfPayDate,
						dfColAccount: "***",
						dfCertificate: this.dfCertificate,
						dfBuyMonths: parseInt( this.dfBuyMonths)
				 };
			this.doTrade( "POST", ServAddr+"/api/fee/devFeeNew", this.onFeeNewOK, true, body, null );
		},
		onFeeNewOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			this.$parent.onPopWinClose2();
			if( data.code == 200 )
				 this.appRoot.app.showDlgTip( 1200, "保存成功", this.CLR.Suc, this.$parent.onPopWinClose, true );
			else this.appRoot.app.showDlgTip( 1200, "保存失败", this.CLR.Err, this.$parent.onPopWinClose, true );
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// feeNew.vue?2cca18fb